// React
import React from 'react';
import config from 'config';
import Utils from '../../utils/utils';
import { Route } from 'react-router-dom';

// Router
import appRouter from '../../router.jsx';
import locationApi from '../../api/location-api';

import UserApi from '../../api/user-api';
import LoginApi from '../../api/login-api';

import Header from './header.component.jsx';
import Footer from './footer.component.jsx';
import BgImg from './bgImg.component.jsx';

import Modal from '../shared/modal.component.jsx';
import Loading from './loading.component.jsx';

class Main extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			canRender: false
		};

		locationApi.setLocation(this.props.location);

		this.authenticateUser = this.authenticateUser.bind(this);
	}

	isPath(path) {
		let regex = new RegExp('/' + path);
		return regex.test(this.props.location.pathname);
	}

	authenticateUser(msisdn, msisdnInHeader) {

		LoginApi.activationStep(config.constants.activationSteps.newUser);
		if (!msisdn) return this.setState({ canRender: true });

		UserApi.getUser(msisdn, msisdnInHeader, true).then(user => {
			if (!user.msisdn) return this.setState({ canRender: true });

			if (UserApi.hasPlanActive(user)) {
				LoginApi.activationStep(config.constants.activationSteps.alreadySubscribed);
			} else {
				LoginApi.activationStep(config.constants.activationSteps.newUser);
			}

			this.setState({ canRender: true });
		});
	}

	//TODO - REVIEW THIS METHOD WHEN GAME IN THE HOME PAGE IS DEVELOPED
	componentWillMount() {

		let userFromSession = Utils.getLocalStorage(config.constants.userSession);

		if (userFromSession && userFromSession.msisdn && UserApi.hasPlanActive(userFromSession)) {
			this.authenticateUser(userFromSession.msisdn);
		} else {
			LoginApi.checkMsisdnInHeader().then(msisdn => {
				LoginApi.activationStep(config.constants.activationSteps.newUser);
				this.authenticateUser(msisdn, true);
			});
		}
	}

	render() {

		const isError = this.isPath('error');

		return (
			<div>
				{/*MODAL*/}
				<Modal />

				{this.state.canRender &&
					<div>

						{/*HEADER*/}
						{isError ? "" : <Header />}

						{/*BODY*/}
						<div id={config.application.bodyContainerId}>
							<Route component={appRouter} />
						</div>

						{/*FOOTER*/}
						<Footer isError={isError} />

					</div>
				}

				{/*LOADING*/}
				<Loading />

				{/*BACKGROUND IMAGE*/}
				{isError ? <BgImg class={'bg-error'} bgImg='/img/bg-error.png' /> : ""}

			</div>
		);
	}
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/core/main.component.jsx